import deliverUserEvent from './deliver-user-event';
import { Layer } from '../../../models/layer-settings';
import activeLayerCountsByType from './layer-count-helper';

export default async function mapLoadedEvent(
  mapEngine: string,
  basemap: string,
  activeOverlays: Layer[],
  view: string,
) {
  const payload = eventPayload(mapEngine, basemap, activeOverlays, view);

  return deliverUserEvent(payload);
}

export const eventPayload = (
  mapEngine: string,
  basemap: string,
  activeOverlays: Layer[],
  view: string,
) => {
  const payload = new FormData();
  payload.append('event_type', 'map');
  payload.append('event_action', 'loaded');
  payload.append('event_data', JSON.stringify({
    web_map_engine: mapEngine,
    basemap,
    layers: activeLayerCountsByType(activeOverlays),
    view,
  }));

  return payload;
};
